import http from "./client";

async function getById(id: number | string) {
  const resp = await http.get('/');


  return resp.data;
}

const lessonTheme = {
  getById
};

export default lessonTheme;